import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useState } from "react";
import { RainfallDetails } from "../mainLayer/rainfall/Rainfall";

// Define the context type
type RainfallContextType = {
  RainfallOpenSidebarMap: Map<string, RainfallDetails>;
  setRainfallOpenSidebarMap: (
    type: string,
    ewsopenMap: RainfallDetails
  ) => void;
  removeFromRainfallOpenSidebarMap: (active_pcode: string) => void;
  clearRainfallOpenSidebarMap: () => void;
  clickedRainfallString: string | null;
  setClickedRainfallString: (value: string) => void;
  isLeftkeyClickRain: boolean;
  setIsLeftkeyClickRain: (value: boolean) => void;
  isLeftRain: boolean;
  setIsLeftRain: (value: boolean) => void;
  isMinEyeClickRain: boolean;
  setIsMinEyeClickRain: (value: boolean) => void;
};

const RainfallContext = createContext<RainfallContextType | undefined>(
  undefined
);

export const RainfallProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [RainfallOpenSidebarMap, setRainfallOpenSidebarMapState] = useState(
    new Map<string, RainfallDetails>()
  );
  const [clickedRainfallString, setClickedRainfallString] = useState<
    string | null
  >(null);
  const [isLeftkeyClickRain, setIsLeftkeyClickRain] = useState(false);
  const [isLeftRain, setIsLeftRain] = useState(false);
  const [isMinEyeClickRain, setIsMinEyeClickRain] = useState(false);

  const setRainfallOpenSidebarMap = (
    type: string,
    RainfallopenMap: RainfallDetails
  ) => {
    setRainfallOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(type, RainfallopenMap);
      return newMap;
    });
  };

  const removeFromRainfallOpenSidebarMap = (sensorId: string) => {
    setRainfallOpenSidebarMapState((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(sensorId);
      return newMap;
    });
  };

  const clearRainfallOpenSidebarMap = () => {
    setRainfallOpenSidebarMapState(new Map());
  };

  // Provide the state and the updater functions
  return (
    <RainfallContext.Provider
      value={{
        RainfallOpenSidebarMap,
        setRainfallOpenSidebarMap,
        removeFromRainfallOpenSidebarMap,
        clearRainfallOpenSidebarMap,
        clickedRainfallString,
        setClickedRainfallString,
        isLeftkeyClickRain,
        setIsLeftkeyClickRain,
        isLeftRain,
        setIsLeftRain,
        isMinEyeClickRain,
        setIsMinEyeClickRain
      }}
    >
      {children}
    </RainfallContext.Provider>
  );
};

// Custom hook for using RainfallContext
export const useRainfallContext = () => {
  const context = useContext(RainfallContext);
  if (!context) {
    throw new Error("useHzContext must be used within an HzProvider");
  }
  return context;
};
